import { createSelector } from 'reselect';

const mailingListIds = (state) => state.mailingLists.ids;

export const getMailingListsById = (state) => state.entities.mailingLists;

export const getIsLoading = (state) => state.mailingLists.isLoading;

export const getActiveMailingListId = (state) => state.mailingLists.activeMailingListId;

export const getActiveMailingList = createSelector(
  [getMailingListsById, getActiveMailingListId],
  (mailingLists, id) => mailingLists[id],
);

export const getAllMailingLists = createSelector(
  [getMailingListsById, mailingListIds],
  (mailingLists, ids) => ids.map((id) => mailingLists[id]),
);
